export default () => {
    const caseStudiesListingComponent = document.querySelectorAll('.case-studies-listing');
    if (caseStudiesListingComponent.length === 0)
        return;
    import(/* webpackChunkName: "case studies listing" */ "./../classes/caseStudiesRive")
        .then(({ default: CaseStudiesRive }) => {
        new CaseStudiesRive();
    })
        .catch(() => "An error with case studies rive component occurred");
};
